import BaseOptionsBundle from "%/dynamic-component-editor/classes/base-options";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import ShowArrows from "%/dynamic-component-editor/options/show-arrows";
import ShowDots from "%/dynamic-component-editor/options/show-dots";
import Snap from "%/dynamic-component-editor/options/snap";
import ItemMinWidth from "%/dynamic-component-editor/options/item-min-width";
import ItemMaxWidth from "%/dynamic-component-editor/options/item-max-width";
import AutoScroll from "%/dynamic-component-editor/options/auto-scroll";
import ScrollSpeed from "%/dynamic-component-editor/options/scroll-speed";
import InfiniteScroll from "%/dynamic-component-editor/options/infinite-scroll";
import ItemsPadding from "%/dynamic-component-editor/options/items-padding";

export default class CarouselOptions extends BaseOptionsBundle {

  optionTitle = "Carousel Options";
  static optionClassName = "i-dynamic-carousel";
  inspectorToolGroup = "carousel";
  useInspectorLabel = false;
  static userInterfaceComponent = {
    component: inspectorTools.CAROUSEL_TOOL_SET,
  };

  constructor(values = {}) {
    super(values, [
      ShowArrows,
      ShowDots,
      Snap,
      AutoScroll,
      ScrollSpeed,
      InfiniteScroll,
      ItemMinWidth,
      ItemMaxWidth,
      ItemsPadding,
    ]);
  }
}
